<template>
  <div>
    <v-form ref="form" lazy-validation>
      <v-text-field
        v-if="!changePassword"
        v-model="Usuario.usuario"
        :rules="rules.nombre"
        label="Usuario"
        outlined
        dense
        required
      ></v-text-field>
      <v-text-field
        v-if="!changePassword"
        v-model="Usuario.displayName"
        :rules="rules.displayname"
        label="Nombre"
        outlined
        dense
        required
      ></v-text-field>
      <v-autocomplete
        v-if="!changePassword"
        v-model="Usuario.type"
        :rules="rules.tipo"
        :items="tipos"
        label="Tipo"
        outlined
        dense
        required
      >
      </v-autocomplete>
      <v-text-field
        v-if="changePassword || enablePassword"
        v-model="Usuario.password"
        :rules="rules.password"
        label="Contraseña"
        outlined
        dense
        required
        :type="show1 ? 'text' : 'password'"
        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append="show1 = !show1"
      ></v-text-field>
      <v-switch
        v-if="!changePassword"
        v-model="Usuario.enable"
        :rules="rules.enable"
        class="ma-0 pa-0"
      >
        <template v-slot:label>
          <v-icon :color="Usuario.enable ? 'success' : 'error'">
            {{ Usuario.enable ? "mdi-check-circle" : "mdi-close-circle" }}
          </v-icon>
          {{ Usuario.enable ? " Usuario Activo " : " Usuario Inactivo " }}
        </template>
      </v-switch>
      <div class="text-right">
        <v-btn  color="success" @click="checkForm()">
          Guardar
        </v-btn>
        <v-btn  @click="$emit('toggle', false)" color="error">
          Cancelar
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "UsuariosAdminForm",
  components: {},
  props: ["edit", "dataEdit", "enablePassword", "usuarios"],
  data() {
    return {
      show1: false,
      tipos: [],
      Usuario: {
        usuario: "",
        displayName: "",
        enable: false,
        type: "",
        password: "",
      },
      rules: {
        nombre: [
          (value) => !!value || "El usuario es obligatorio",
          (value) => !this.allUsers.has(value) || "Este usuario ya existe",
        ],
        tipo: [(value) => !!value || "El tipo es obligatorio"],
        displayname: [(value) => !!value || "El nombre es obligatorio"],
        password: [
          (value) => !!value || "La contraseña es obligatoria",
          (value) =>
            value.length >= 8 ||
            "La contraseña debe tener al menos 8 caracteres",
        ],
        // enable: [(value) => value || 'El departamento es obligatorio'],
      },
      allUsers: new Map(),
      changePassword: false,
    };
  },
  methods: {
    checkForm() {
      const valid = this.$refs.form.validate();
      if (valid) {
        this.$emit("sendData", this.Usuario, this.edit, this.changePassword);
      }
    },
    async getTipos() {
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "GBL/RolesUsuario"
        );

      this.tipos = [];
      this.tipos = Object.values(data.val());
    },
  },
  computed: {},
  watch: {},
  beforeMount: async function () {
    await this.getTipos();
  },
  mounted() {
    if (this.edit && !this.enablePassword) {
      this.Usuario = this.$pgsHelper.cloneObj(this.dataEdit);
    }
    if (this.enablePassword && this.edit) {
      this.Usuario = this.$pgsHelper.cloneObj(this.dataEdit);
      this.Usuario.password = "";
      this.changePassword = true;
    }
    if (Array.isArray(this.usuarios)) {
      this.allUsers = new Map(this.usuarios.map((user) => [user, true]));
      if (this.edit) {
        this.allUsers.delete(this.Usuario.usuario);
      }
    }
  },
};
</script>

<style scoped></style>
